/* Pins & Co shared card behavior: reveal, quick add, variant swap, inventory-aware stepper, add-on checkbox */
(function () {
  if (window.__pcCardsInit) return;
  window.__pcCardsInit = true;

  /* variant_id -> qty already in cart */
  var pcCart = {};

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        pcCart = {};
        (c.items || []).forEach(function (it) {
          pcCart[it.variant_id] = (pcCart[it.variant_id] || 0) + it.quantity;
        });
        applyAllCaps();
      })
      .catch(function () { /* noop */ });
  }

  function capOf(qa) {
    var raw = qa.getAttribute('data-inv');
    var stock = raw === null || raw === '' ? NaN : parseInt(raw, 10);
    if (isNaN(stock)) stock = 99; /* untracked or continue-selling: unlimited */
    var vid = Number(qa.getAttribute('data-variant-id'));
    var inCart = pcCart[vid] || 0;
    return Math.max(0, Math.min(99, stock - inCart));
  }

  function applyCap(qa) {
    var qty = qa.querySelector('.pc-qty');
    var plus = qa.querySelector('.pc-step-btn[data-step="1"]');
    var minus = qa.querySelector('.pc-step-btn[data-step="-1"]');
    var addBtn = qa.querySelector('.pc-add');
    if (!qty || !addBtn) return;
    var cap = capOf(qa);

    if (cap <= 0) {
      qty.value = 0;
      qty.disabled = true;
      if (plus) plus.disabled = true;
      if (minus) minus.disabled = true;
      addBtn.disabled = true;
      addBtn.setAttribute('data-pc-maxed', '1');
      addBtn.textContent = 'Max in cart';
      return;
    }

    qty.disabled = false;
    if (minus) minus.disabled = false;
    var val = parseInt(qty.value || '1', 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > cap) val = cap;
    qty.value = val;
    qty.setAttribute('max', cap);
    if (plus) plus.disabled = val >= cap;
    if (addBtn.getAttribute('data-pc-maxed')) {
      addBtn.removeAttribute('data-pc-maxed');
      addBtn.disabled = false;
      addBtn.textContent = 'Add';
    }
  }

  function applyAllCaps() {
    document.querySelectorAll('.pc-qa-add').forEach(applyCap);
  }

  function init() {
    /* Injected styles: disabled stepper + add-on row */
    if (!document.getElementById('pc-cards-style')) {
      var st = document.createElement('style');
      st.id = 'pc-cards-style';
      st.textContent = '.pc-step-btn:disabled{opacity:.28;cursor:default}.pc-step-btn:disabled:hover{background:none}.pc-qty:disabled{opacity:.4}' +
        '.pc-prod-sold{display:block;margin-top:.25rem;font-size:1.06rem;letter-spacing:.04em;color:rgba(28,28,28,.48)}' +
        '.pc-addon{display:flex;align-items:center;gap:.55rem;margin-top:.7rem;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
        '.pc-addon__box{width:1.5rem;height:1.5rem;flex:0 0 auto;margin:0;accent-color:#A20606;cursor:pointer}' +
        '.pc-addon__text{font-size:1.1rem;line-height:1.3;color:rgba(28,28,28,.72);letter-spacing:.01em}' +
        '.pc-addon__price{color:#A20606;font-weight:600}' +
        '.pc-addon__per{color:rgba(28,28,28,.5)}' +
        '.pc-addon__info{flex:0 0 auto;width:1.4rem;height:1.4rem;border-radius:50%;border:1px solid rgba(162,6,6,.4);color:#A20606;font-size:.95rem;font-weight:700;line-height:1;display:inline-flex;align-items:center;justify-content:center;text-decoration:none}' +
        '.pc-addon__info:hover{background:#A20606;color:#fff;border-color:#A20606}';
      document.head.appendChild(st);
    }

    /* Fast scroll-in reveal for product cards (vertical + horizontal) */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards = document.querySelectorAll('.pc-landing-carousel .pc-anim, .pc-grid .pc-anim');
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '160px 160px 160px 160px', threshold: 0.03 });

      document.querySelectorAll('.pc-landing-carousel, .pc-grid').forEach(function (container) {
        container.querySelectorAll('.pc-anim').forEach(function (el, i) {
          el.style.transitionDelay = Math.min(i, 5) * 22 + 'ms';
          io.observe(el);
        });
      });
    } else {
      cards.forEach(function (el) { el.classList.add('in'); });
    }

    /* Keep the add-on checkbox from following the card link */
    document.querySelectorAll('.pc-addon').forEach(function (row) {
      if (row.__pcBound) return;
      row.__pcBound = true;
      row.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    /* Quantity + add-to-cart */
    document.querySelectorAll('.pc-qa-add').forEach(function (qa) {
      if (qa.__pcBound) return;
      qa.__pcBound = true;
      var qty = qa.querySelector('.pc-qty');
      var addBtn = qa.querySelector('.pc-add');
      if (!qty || !addBtn) return;

      qa.querySelectorAll('.pc-step-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var cap = capOf(qa);
          var current = parseInt(qty.value || '1', 10);
          var next = current + parseInt(btn.getAttribute('data-step'), 10);
          qty.value = Math.min(cap > 0 ? cap : 1, Math.max(1, next));
          applyCap(qa);
        });
      });

      qty.addEventListener('change', function () {
        var cap = capOf(qa);
        var val = parseInt(qty.value || '1', 10);
        if (isNaN(val) || val < 1) val = 1;
        qty.value = Math.min(cap > 0 ? cap : 1, val);
        applyCap(qa);
      });

      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var requested = Math.max(1, parseInt(qty.value || '1', 10));
        var cap = capOf(qa);
        if (cap > 0 && requested > cap) {
          requested = cap;
          qty.value = cap;
        }
        addBtn.disabled = true;
        var original = 'Add';
        addBtn.textContent = '…';

        var vid = Number(qa.getAttribute('data-variant-id'));
        var items = [{ id: vid, quantity: requested }];

        /* Add-on: per-unit quantity × main product quantity, capped by add-on stock */
        var card = qa.closest('.pc-prod-card');
        var addonBox = card ? card.querySelector('.pc-addon__box') : null;
        var addonId = null;
        var addonQty = 0;
        if (addonBox && addonBox.checked) {
          addonId = Number(addonBox.getAttribute('data-addon-variant'));
          var per = parseInt(addonBox.getAttribute('data-addon-per') || '1', 10);
          if (isNaN(per) || per < 1) per = 1;
          addonQty = per * requested;

          var stockRaw = addonBox.getAttribute('data-addon-stock');
          var addonStock = stockRaw === null || stockRaw === '' ? NaN : parseInt(stockRaw, 10);
          if (!isNaN(addonStock)) {
            var addonLeft = Math.max(0, addonStock - (pcCart[addonId] || 0));
            addonQty = Math.min(addonQty, addonLeft);
          }
          if (addonId && addonQty > 0) {
            items.push({ id: addonId, quantity: addonQty });
          } else {
            addonQty = 0;
          }
        }

        var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: items };
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          try {
            body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          } catch (err) { /* noop */ }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
          .then(function (result) {
            if (result.ok) {
              pcCart[vid] = (pcCart[vid] || 0) + requested;
              if (addonId && addonQty > 0) {
                pcCart[addonId] = (pcCart[addonId] || 0) + addonQty;
              }
              if (addonBox) addonBox.checked = false;
              if (cartEl && typeof cartEl.renderContents === 'function' && result.json.sections) {
                try { cartEl.renderContents(result.json); } catch (err) { /* noop */ }
              }
              addBtn.textContent = '✓ Added';
              addBtn.classList.add('is-added');
            } else {
              /* Stock race (e.g. someone else bought it): sync and cap instead of a raw error */
              addBtn.textContent = 'Not enough stock';
              refreshCart();
            }
            setTimeout(function () {
              addBtn.classList.remove('is-added');
              if (!addBtn.getAttribute('data-pc-maxed')) {
                addBtn.textContent = original;
                addBtn.disabled = false;
              }
              applyCap(qa);
            }, 1600);
          })
          .catch(function () {
            addBtn.textContent = 'Error';
            setTimeout(function () {
              addBtn.textContent = original;
              addBtn.disabled = false;
              applyCap(qa);
            }, 1600);
          });
      });
    });

    /* Variant dropdown: instant image + price + inventory-cap swap */
    document.querySelectorAll('.pc-var-select').forEach(function (sel) {
      if (sel.__pcBound) return;
      sel.__pcBound = true;
      sel.addEventListener('change', function () {
        var card = sel.closest('.pc-prod-card');
        if (!card) return;
        var opt = sel.selectedOptions[0];
        if (!opt || !opt.value) return;

        var addWrap = card.querySelector('.pc-qa-add');
        if (addWrap) {
          addWrap.setAttribute('data-variant-id', opt.value);
          addWrap.setAttribute('data-inv', opt.getAttribute('data-inv') || '');
          var q = addWrap.querySelector('.pc-qty');
          if (q && !q.disabled && (parseInt(q.value, 10) < 1 || isNaN(parseInt(q.value, 10)))) q.value = 1;
          if (q && q.disabled) q.value = 1; /* reset from a maxed variant */
          applyCap(addWrap);
        }

        var img = card.querySelector('.pc-prod-img img');
        var newSrc = opt.getAttribute('data-image');
        if (img && newSrc) {
          img.style.opacity = '0';
          img.removeAttribute('srcset');
          var restore = function () { img.style.opacity = '1'; };
          img.onload = restore;
          img.src = newSrc;
          setTimeout(restore, 250);
        }

        var priceEl = card.querySelector('.pc-prod-price');
        var newPrice = opt.getAttribute('data-price');
        var newCompare = opt.getAttribute('data-compare');
        if (priceEl && newPrice) {
          if (newCompare) {
            priceEl.classList.add('on-sale');
            var s = document.createElement('s');
            s.textContent = newCompare;
            priceEl.textContent = newPrice;
            priceEl.insertBefore(s, priceEl.firstChild);
          } else {
            priceEl.classList.remove('on-sale');
            priceEl.textContent = newPrice;
          }
        }
      });
    });

    /* Keep caps in sync with cart changes made in the drawer */
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(); });
      } catch (err) { /* noop */ }
    }

    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
